import SkillResponse from './skill/entity/skill-response';

export default class EmployeeAssessmentResponse {
  levelId: string;

  skillResponses: SkillResponse[];

  assessmentId: string;

  constructor(obj: any = {}) {
    this.levelId = obj.levelId || '';
    this.skillResponses = [];
    this.assessmentId = obj.assessmentId || '';
  }
}
